export const EXPERIMENTS = {
  ENABLE_MULTILINE_ADDRESS: 'specs.forms.MultilineAddressInTemplates',
  SHOW_DEMO_FORM: 'specs.forms.ShowDemoForm',
  USE_CSS_VARS_ONLY: 'specs.forms.UseCSSVarsOnly',
  ENABLE_PRESET_TAB: 'specs.forms.EnablePresetTab',
};
